import {
  apiEndpoints,
  APP_ID_SPACE,
  BASE_URL,
  REGION_SPACE,
} from './endpoints';
import { encodeQueryData, getAPI } from './helper';

export class APIHandler {
  private static appSettings: any;

  /**
   * Sets the app settings for the APIHandler class.
   * @param appSettings - The CallAppSettings object containing the app settings.
   */
  public static setAppSettings(appSettings: any) {
    this.appSettings = appSettings;
  }

  /**
   * Gets the call log list for the given filter parameters and authentication token.
   * @param params - The object containing the filter parameters.
   * @param authToken - The authentication token.
   * @returns A Promise that resolves to an array of call log objects.
   */
  public static async getCallLogList(
    params: object,
    authToken: string,
  ): Promise<any> {
    let url = BASE_URL.replace(APP_ID_SPACE, this.appSettings.appId).replace(
      REGION_SPACE,
      this.appSettings.region as string,
    );

    if (this.appSettings.host) {
      url = this.appSettings.host as string;
    }

    const querystring = encodeQueryData(params);
    const finalEndpoint = `${url}${apiEndpoints.CALL_LIST}?${querystring}`;

    return getAPI({
      url: finalEndpoint,
      headers: {
        authToken,
      },
    });
  }

  /**
   * Gets the call details for the given session ID and authentication token.
   * @param sessionID - The session ID for which the call details are to be fetched.
   * @param authToken - The authentication token.
   * @returns A Promise that resolves to a call details object.
   */
  public static async getCallDetails(
    sessionID: string,
    authToken: string,
  ): Promise<any> {
    let url = BASE_URL.replace(APP_ID_SPACE, this.appSettings.appId).replace(
      REGION_SPACE,
      this.appSettings.region as string,
    );

    if (this.appSettings.host) {
      url = this.appSettings.host as string;
    }

    return getAPI({
      url: `${url}${apiEndpoints.CALL_LIST}/${sessionID}`,
      headers: {
        authToken,
      },
    });
  }
}
